import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { componentSpacing02, componentSpacing03, componentSpacing04 } from '../../tokens';
var primaryInitialColors = {
  color: '$color.neutral.00',
  borderColor: '$color.primary.main',
  backgroundColor: '$color.primary.main'
};
var primaryDangerInitialColors = {
  borderColor: '$color.error.main',
  backgroundColor: '$color.error.main'
};
var tertiaryInitialColors = {
  color: '$color.primary.main'
};
var tertiaryDangerInitialColors = {
  color: '$color.error.main'
};
export var buttonDefaultTheme = {
  Root: {
    base: {
      fontWeight: '$typography.labelMedium.fontWeight',
      letterSpacing: '$typography.labelMedium.letterSpacing',
      fontSize: '$typography.labelMedium.fontSize',
      fontFamily: '$typography.body.fontFamily',
      lineHeight: '$typography.labelMedium.lineHeight',
      borderRadius: '$shape.borderRadius.soft',
      backgroundColor: 'transparent',
      paddingLeft: componentSpacing04,
      paddingRight: componentSpacing04,
      paddingTop: componentSpacing03,
      paddingBottom: componentSpacing03
    },
    small: {
      paddingTop: componentSpacing02,
      paddingBottom: componentSpacing02
    },
    primary: _objectSpread(_objectSpread({}, primaryInitialColors), {}, {
      '&:hover': {
        color: '$color.neutral.00',
        borderColor: '$color.primary.light',
        backgroundColor: '$color.primary.light'
      },
      '&:focus': {
        color: '$color.neutral.00',
        borderColor: '$color.primary.light',
        backgroundColor: '$color.primary.light'
      },
      '&:active': {
        color: '$color.neutral.00',
        borderColor: '$color.primary.dark',
        backgroundColor: '$color.primary.dark'
      },
      '&:disabled': {
        color: '$color.neutral.04',
        borderColor: '$color.neutral.03',
        backgroundColor: '$color.neutral.03'
      },
      '&:focus:not(:active)': _objectSpread({}, primaryInitialColors)
    }),
    primary__danger: _objectSpread(_objectSpread({}, primaryDangerInitialColors), {}, {
      '&:hover': {
        borderColor: '$color.error.light',
        backgroundColor: '$color.error.light'
      },
      '&:focus': {
        borderColor: '$color.error.light',
        backgroundColor: '$color.error.light'
      },
      '&:active': {
        borderColor: '$color.error.dark',
        backgroundColor: '$color.error.dark'
      },
      '&:disabled': {
        color: '$color.neutral.04',
        borderColor: '$color.neutral.03',
        backgroundColor: '$color.neutral.03'
      },
      '&:focus:not(:active)': _objectSpread({}, primaryDangerInitialColors)
    }),
    secondary: {
      color: '$color.primary.main',
      borderColor: '$color.primary.main',
      backgroundColor: 'transparent',
      '&:hover': {
        color: '$color.primary.light',
        borderColor: '$color.primary.light',
        backgroundColor: '$color.primary.lightest'
      },
      '&:focus': {
        color: '$color.primary.light',
        borderColor: '$color.primary.light'
      },
      '&:active': {
        color: '$color.primary.dark',
        borderColor: '$color.primary.dark'
      },
      '&:disabled': {
        color: '$color.neutral.04',
        borderColor: '$color.neutral.03',
        backgroundColor: '$color.neutral.03'
      }
    },
    secondary__danger: {
      color: '$color.error.main',
      borderColor: '$color.error.main',
      '&:hover': {
        color: '$color.error.light',
        borderColor: '$color.error.light'
      },
      '&:focus': {
        color: '$color.error.light',
        borderColor: '$color.error.light'
      },
      '&:active': {
        color: '$color.error.dark',
        borderColor: '$color.error.dark'
      }
    },
    tertiary: _objectSpread(_objectSpread({}, tertiaryInitialColors), {}, {
      '&:hover': {
        color: '$color.primary.light'
      },
      '&:focus': {
        color: '$color.primary.light'
      },
      '&:active': {
        color: '$color.primary.dark'
      },
      '&:disabled': {
        color: '$color.neutral.04'
      },
      '&:focus:not(:active)': _objectSpread({}, tertiaryInitialColors)
    }),
    tertiary__danger: _objectSpread(_objectSpread({}, tertiaryDangerInitialColors), {}, {
      '&:hover': {
        color: '$color.error.main'
      },
      '&:focus': {
        color: '$color.error.main'
      },
      '&:active': {
        color: '$color.error.main'
      },
      '&:disabled': {
        color: '$color.neutral.04'
      },
      '&:focus:not(:active)': _objectSpread({}, tertiaryDangerInitialColors)
    })
  }
};